// extracted by mini-css-extract-plugin
module.exports = {"customFormItem":"editForm_customFormItem__3nMTA"};